export default __webpack_public_path__ + "static/media/icon-font.0215ff75.svg";